import React, { useEffect, useState, useContext, useRef } from 'react'
import TableMaternidad from './TableMaternidad';
import CrearMaternidad from './modales/CrearMaternidad';
import PageHeader from '../../components/pageHeader/PageHeader';
import PageButtons from '../../components/pageComponents/PageButtons';
import PageWrapper from '../../components/pageComponents/PageWrapper';
import ModalEnabled from '../../components/modalComponents/ModalEnabled';
import SearchContainer from '../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../hooks/useDidMountEffect/useDidMountEffect';
import { useGetRequest } from '../../hooks/useGetRequest/useGetRequest';
import { useManagePostRequest } from '../../hooks/useManagePostRequest/useManagePostRequest';
import { initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData } from '../../helper/utils';
import {
  getAllCargosAPI,
  getAllEstadosAPI,
  getAllSedesAPI,
  getListaMisCondicionesAPI,
  getMotivoTerminoMaternidadAPI,
  getAllTipoCondicionAPI,
  getAllDepartamentosAPI,
  getAllTiposLicenciasAPI, getAllNivelesAprobacionCondicionAPI
} from '../../consumers/backendApisUrls';

import { AuthContext } from '../../hooks/context/authContext';

const INIT_KEYS = {
  departamentos: "IdsDepartamentos",
  cargos: "IdsCargos",
  sedes: "IdsSedes",
  estadosAprobacion: "IdsEstadosAprobacion",
  estadoProceso: "IdsEstadosProceso",
  condicion: "IdsTipoDeCondicion",
  motivo: "IdsMotivoTerminoMaternidad",
  preExistencia: "IdsPreExistencia",
  subsidio: "IdsTieneSubsidio",
  IdsTipoLicenciaCondicion: "IdsTipoLicenciaCondicion",
  IdsNivelesAprobacion:"IdsNivelesAprobacion"
};

const MiRegistroMaternidad = () => {
  const { state } = useContext(AuthContext);


  const [formValues, setFormValues] = useState({ Items: [], ExtraData: {}, filters: [], selectedFilters: {} });
  const [allFilters, setAllFilters] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);

  const [modalEnabled, setModalEnabled] = useState({ isEnable: false, component: React.Fragment });
  const [selectedIds, setSelectedIds] = useState(new Set());
  const selectAllRef = useRef(null);

  const [executeGet] = useGetRequest();
  const [executeManagePost] = useManagePostRequest();

  const initialPromises = () => {
    const response = executeGet(getAllEstadosAPI());

    return [
      executeGet(getAllDepartamentosAPI()),
      executeGet(getAllCargosAPI()),
      executeGet(getAllSedesAPI()),
      response,
      response,
      executeGet(getAllTipoCondicionAPI()),
      executeGet(getMotivoTerminoMaternidadAPI()),
      response,
      response,
      executeGet(getAllTiposLicenciasAPI()),
      executeGet(getAllNivelesAprobacionCondicionAPI())
    ];
  }

  const init = async () => {
    setIsLoading(true);
    try {
      await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
      await manageSearch();
      if (formValues.filters.length === 0) {
        jsonNoEstaVacio(formValues.ExtraData) &&
          updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
      }



    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const manageSearch = async () => {
    const api = getListaMisCondicionesAPI();
    const payload = getPayload();
    await executeManagePost(api, payload, successManageSearchCallback);
  }

  const getPayload = () => {
    return {
      Criteria: searchCriteria,
      Page: paginator.CurrentPage,
      ...formValues.selectedFilters
    }
  }

  const successManageSearchCallback = ({ data }) => {
    const { Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage } = data;
    setFormValues(lastData => ({ ...lastData, Items, ExtraData }));
    setPaginator({ TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage });
  }

  const handleUpdatedFilters = (res) => {
    setFormValues(lastData => ({ ...lastData, filters: res }))
  }

  const handleCleanSearch = () => {
    setFormValues({ ...formValues, selectedFilters: null });
  }

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters])

  useDidMountEffect(() => {
    jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
  }, [formValues.ExtraData])

  useEffect(() => {
    init();
  }, [])

  return (
    <PageWrapper isLoading={isLoading}>
      <ModalEnabled
        modalEnabled={modalEnabled}
        setModalEnabled={setModalEnabled}
        refreshPage={manageSearch}
      />
      <PageHeader title="Listado de registros de DM y/o maternidad" />
      
      <SearchContainer
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        setPaginator={setPaginator}
        manageSearch={manageSearch}
        addCleanSearch={handleCleanSearch}>
        <PageButtons
          hasCreateButton
          handleCreateButton={() =>
            setModalEnabled({ isEnable: true, component: CrearMaternidad, data: { isAdmin: false, idEmpleado: state.user.id_empleado } })
          }
        />
      </SearchContainer>
      <TableMaternidad
        formValues={formValues}
        setFormValues={setFormValues}
        extraData={formValues.ExtraData}
        setModalEnabled={setModalEnabled}
        paginator={paginator}
        setPaginator={setPaginator}
        keys={INIT_KEYS}
        isAdmin={false}
        fromAdminPage={false}
        manageSearch={manageSearch}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        selectAllRef={selectAllRef}
      />
     
    </PageWrapper>
  );
}

export default MiRegistroMaternidad